import React, { useState } from 'react';
import { Modal, Box, Typography, IconButton, Button, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TemplateForm from './TemplateForm';

const style = {
  position: 'absolute',
  top: '50px',
  left: '50%',
  transform: 'translateX( -50%)',
  width: 600,
  height: "max-content",
  maxHeight: "95vh",
  maxWidth: "90vw",
  overflowY: "scroll",
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
};

const EventModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCloseModal = () => setIsOpen(false);
  const handleSubmitModal = (event) => setIsOpen(false);

  return (
    <Stack>
      <Button
        variant="contained"
        component="label"
        onClick={() => setIsOpen(true)}
        sx={{
          backgroundColor: '#9f1d21',
          '&:hover': {
            backgroundColor: '#e3272c', // optional darker shade for hover
          },
        }}
      >
        Map Event
      </Button>
      <Modal open={isOpen} onClose={handleCloseModal} aria-labelledby="modal-modal-title">
        <Box sx={style}>
          <Stack direction='row' justifyContent='space-between' mb={4}>
            <Typography variant="h6">Map Event</Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseModal}
              sx={{
                width: "20px",
                height: "20px",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>

          <TemplateForm onClose={handleSubmitModal} />
        </Box>
      </Modal>
    </Stack>
  );
};

export default EventModal;